// extracted by mini-css-extract-plugin
export var gif = "_m3-0";